var _circle, _circle2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#FADEDE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.998,
    cy: 36,
    r: 25,
    fill: "#C50000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M36.1075 48.5C35.9527 48.5 35.7992 48.4645 35.6595 48.3921L31.1578 46.062C29.8792 45.4001 28.88 44.6573 28.1009 43.7919C26.3919 41.8994 25.443 39.47 25.4266 36.9499L25.375 28.6553C25.3688 27.698 25.9854 26.8388 26.9092 26.5152L35.1749 23.6335C35.667 23.4582 36.2145 23.4558 36.7128 23.6249L45.0101 26.4086C45.9389 26.7187 46.5668 27.5718 46.5719 28.5279L46.6247 36.8285C46.6411 39.345 45.7249 41.7842 44.0436 43.6976C43.2708 44.5752 42.2817 45.329 41.0169 46.0032L36.5555 48.386C36.4171 48.4608 36.2623 48.4988 36.1075 48.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3347 35.6561L39.0324 34.0026C39.4011 33.6435 39.4011 33.0625 39.0324 32.7033C38.6637 32.3442 38.0659 32.3442 37.6971 32.7033L35.9994 34.3556L34.303 32.7033C33.9342 32.3442 33.3365 32.3442 32.9677 32.7033C32.599 33.0625 32.599 33.6435 32.9677 34.0026L34.6654 35.6561L32.9677 37.3096C32.599 37.6688 32.599 38.2498 32.9677 38.6089C33.1527 38.7891 33.3943 38.8786 33.636 38.8786C33.8763 38.8786 34.118 38.7891 34.303 38.6089L35.9994 36.9566L37.6971 38.6089C37.8821 38.7891 38.1225 38.8786 38.3641 38.8786C38.6058 38.8786 38.8474 38.7891 39.0324 38.6089C39.4011 38.2498 39.4011 37.6688 39.0324 37.3096L37.3347 35.6561Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error_icon.8c34c95c91840857d9e6cb441041bf46.svg";
export { ForwardRef as ReactComponent };